// Juo Subscriptions Widget - Main Script - Natulim DB 18/02/2026 Cambio 

// Collapsible functionality
function createCollapsible(el, initial) {
  if (initial === void 0) {
    initial = false;
  }

  var isOpen = initial;

  el.style.height = isOpen ? "auto" : "0";
  el.style.overflow = "hidden";

  function open() {
    if (isOpen) {
      return;
    }
    isOpen = true;

    var currentHeight = getComputedStyle(el).height;
    el.style.height = "auto";
    var height = getComputedStyle(el).height;
    el.style.height = currentHeight;
    getComputedStyle(el).height;
    requestAnimationFrame(function () {
      el.style.height = height;
    });
  }

  function close() {
    if (!isOpen) {
      return;
    }
    isOpen = false;

    var height = getComputedStyle(el).height;
    el.style.height = height;
    getComputedStyle(el).height;
    requestAnimationFrame(function () {
      el.style.height = "0";
    });
  }

  el.style.transition = "height 300ms ease-in-out";
  el.addEventListener("transitionend", function (e) {
    if (e.target !== el) {
      return;
    }
    if (isOpen) {
      el.style.height = "auto";
    }
  });

  return {
    open: open,
    close: close,
    el: el,
  };
}

// Format Money functionality
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split(".");
    var dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    var cents_part = parts[1] ? decimal + parts[1] : "";

    return dollars + cents_part;
  }

  var match = formatString.match(placeholderRegex);
  if (match) {
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

// Main Widget Logic
(function () {
  function updatePrice(el, value, moneyFormat) {
    if (el == null) {
      return;
    }
    return (el.innerHTML =
      '<span class="money">' + formatMoney(value, moneyFormat) + "</span>");
  }

  function getAllocatedSellingPlanById(variant, id) {
    return variant.sellingPlans.find(function (plan) {
      return plan.id === Number(id);
    });
  }

  function initSellingPlanInput(form) {
    var el = form.querySelector('input[name="selling_plan"]');

    if (!el) {
      el = document.createElement("input");
      el.type = "hidden";
      el.name = "selling_plan";
      form.append(el);
    }

    return el;
  }

  // Natulim DB 18/02/2026 Cambio: initWidget recibe widgetNode
  function initWidget(variants, variantId, moneyFormat, widgetNode) {

    var widget = widgetNode;
    if (!widget) return;

    // Buscamos el formulario padre de ESTE widget específico
    var parentForm = widget.closest('form');

    // Si no encontramos form directo, buscamos globalmente (fallback)
    var forms = parentForm ? [parentForm] : Array.from(document.querySelectorAll('form[action$="/cart/add"]'));
    var sellingPlanInputs = forms.map(initSellingPlanInput);

    // Initialize SubscriptionWidgetConfig
    if (!window.SubscriptionWidgetConfig) {
      window.SubscriptionWidgetConfig = { formattedPrices: {} };
    }

    // Build formatted prices
    variants.forEach(function (variant) {
      var formattedUnit =
        '<span class="money">' +
        formatMoney(variant.price, moneyFormat) +
        "</span>";
      var sellingPlansFormatted = {};

      variant.sellingPlans.forEach(function (plan) {
        sellingPlansFormatted[plan.id] = {
          price:
            '<span class="money">' +
            formatMoney(plan.price, moneyFormat) +
            "</span>",
        };
      });

      window.SubscriptionWidgetConfig.formattedPrices[variant.id] = {
        unit: formattedUnit,
        sellingPlans: sellingPlansFormatted,
      };
    });

    var priceElement = widget.querySelector('[part="subscription-price"]');
    var basePriceElement = widget.querySelector('[part="price price--base"]');
    var comparePriceElement = widget.querySelector('[part="compare-price"]');
    var sellingPlanSelectorElement = widget.querySelector('[part="select"]');

    if (!sellingPlanSelectorElement) {
      return;
    }

    function getMode() {
      var checkedInput = widget.querySelector('input[name="mode"]:checked');
      return checkedInput ? checkedInput.value : "otp";
    }

    function getValue() {
      if (getMode() === "otp") {
        return "";
      }

      var checkedPlan = widget.querySelector(
        'input[name="selling_plan"]:checked'
      );
      return checkedPlan ? checkedPlan.value : "";
    }

    function populateSellingPlanId() {
      var value = getValue();

      sellingPlanInputs.forEach(function (sellingPlanInput) {
        sellingPlanInput.value = value;
        sellingPlanInput.dispatchEvent(new Event("change", { bubbles: true }));
      });

      document.dispatchEvent(new CustomEvent("natulimOptionValueChanged"));
    }

    // --- Natulim DB 18/02/2026 Cambio: CORRECCIÓN CRÍTICA PARA QUICK ADD Y DAWN V15 ---
    function getActiveVariant() {
      // 1. Buscamos el contenedor principal del producto (product-info)
      // Esto es vital porque en Dawn los botones de variantes están FUERA del form
      var productContainer = widget.closest('product-info') || widget.closest('.product') || widget.closest('form');

      if (productContainer) {
        // Buscamos el input "id" dentro de este contenedor global
        var variantInput = productContainer.querySelector('input[name="id"]');

        if (variantInput && variantInput.value) {
          var foundVariant = variants.find(function (v) { return v.id == variantInput.value; });
          if (foundVariant) return foundVariant;
        }
      }

      // 2. Fallback: URL (solo sirve para Product Page normal)
      var url = new URL(window.location.href);
      var activeVariantId = url.searchParams.get("variant") || variantId;

      return (
        variants.find(function (v) {
          return v.id == activeVariantId;
        }) || variants.find(Boolean)
      );
    }
    // --- FIN CORRECCIÓN ---

    function updateSaveBadge(comparePrice, price) {
      var saveElement = widget.querySelector('[data-ref="save"]');

      if (saveElement) {
        var percentage = (price / comparePrice) * 100;
        saveElement.innerHTML = "" + (100 - Math.round(percentage));
      }
    }

    function updateSellingPlans(sellingPlans, activeVariantId) {
      sellingPlans = sellingPlans || [];

      if (
        sellingPlanSelectorElement.dataset.activeVariant ===
        String(activeVariantId)
      ) {
        return;
      }

      var html = "";
      sellingPlans.forEach(function (plan, index) {
        var checked = index === 0 ? "checked" : "";
        html += '<label class="j-plan-button">';
        html +=
          '<input type="radio" name="selling_plan" value="' +
          plan.id +
          '" ' +
          checked +
          ">";
        html += '<span class="j-plan-button-text">' + plan.name + "</span>";
        html += "</label>";
      });
      sellingPlanSelectorElement.innerHTML = html;

      if (sellingPlans.length === 0) {
        return;
      }

      sellingPlanSelectorElement.dataset.activeVariant = activeVariantId;

      var planRadios = sellingPlanSelectorElement.querySelectorAll(
        'input[name="selling_plan"]'
      );
      planRadios.forEach(function (radio) {
        radio.addEventListener("change", function () {
          populateSellingPlanId();
          updateView();
        });
      });

      populateSellingPlanId();
    }

    function updateView() {
      var activeVariant = getActiveVariant();
      var mode = getMode();

      updateSellingPlans(activeVariant.sellingPlans, activeVariant.id);

      var allocatedPlan = getAllocatedSellingPlanById(
        activeVariant,
        getValue()
      );

      if (
        !allocatedPlan &&
        activeVariant.sellingPlans &&
        activeVariant.sellingPlans.length > 0
      ) {
        allocatedPlan = activeVariant.sellingPlans[0];
      }

      // --- Natulim DB 18/02/2026 Cambio: Nombre de Grupo desde JSON ---
      var textPartEl = widget.querySelector('.j-plan-text-part');
      var htmlPartEl = widget.querySelector('.j-plan-html-part');

      if (textPartEl && htmlPartEl) {
        var displayString = allocatedPlan ? (allocatedPlan.group_name || allocatedPlan.name) : '';

        if (displayString) {
          var splitIndex = displayString.indexOf('<');
          if (splitIndex !== -1) {
            textPartEl.innerText = displayString.substring(0, splitIndex).trim();
            htmlPartEl.innerHTML = displayString.substring(splitIndex);
          } else {
            textPartEl.innerText = displayString;
            htmlPartEl.innerHTML = "";
          }
        } else {
          textPartEl.innerText = "Subscrever";
          htmlPartEl.innerHTML = "";
        }
      }

      updatePrice(basePriceElement, activeVariant.price, moneyFormat);

      var otpComparePriceElement = widget.querySelector(
        '.j-otp [part="compare-price"]'
      );
      if (
        activeVariant.comparePrice &&
        activeVariant.comparePrice > activeVariant.price
      ) {
        updatePrice(
          otpComparePriceElement,
          activeVariant.comparePrice,
          moneyFormat
        );
      } else if (otpComparePriceElement) {
        otpComparePriceElement.innerHTML = "";
      }

      if (allocatedPlan) {
        widget.classList.remove("juo-hidden");
        updatePrice(priceElement, allocatedPlan.price, moneyFormat);

        if (allocatedPlan.comparePrice > allocatedPlan.price) {
          updateSaveBadge(allocatedPlan.comparePrice, allocatedPlan.price);
        }

        if (
          allocatedPlan.price < allocatedPlan.comparePrice &&
          activeVariant.price !== allocatedPlan.price
        ) {
          updatePrice(
            comparePriceElement,
            allocatedPlan.comparePrice,
            moneyFormat
          );
        } else if (comparePriceElement) {
          comparePriceElement.innerHTML = "";
        }
      } else {
        if (mode === "subscription") {
          widget.classList.add("juo-hidden");
        } else {
          widget.classList.remove("juo-hidden");
        }
      }
    }

    var collapsibleEl = widget.querySelector(".collapsible");
    var collapsible =
      collapsibleEl == null
        ? null
        : createCollapsible(collapsibleEl, getMode() === "subscription");

    // Natulim DB 18/02/2026 Cambio: Fix bucle infinito + Debounce para evitar flicker
    var updateTimeout;
    function update(e) {
      if (e && e.target && e.target.name === 'selling_plan') {
        return;
      }

      // Debounce: evitar múltiples actualizaciones rápidas que causen flicker
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(function() {
        populateSellingPlanId();
        updateView();

        if (collapsible) {
          if (getMode() === "subscription") {
            collapsible.open();
          } else {
            collapsible.close();
          }
        }
      }, 10);
    }

    update();
    // Escuchamos cambios solo en este widget
    widget.addEventListener("change", update);

    sellingPlanSelectorElement.addEventListener("click", function (e) {
      if (
        e.target.name === "selling_plan" ||
        e.target.closest(".j-plan-button")
      ) {
        var subscriptionRadio = widget.querySelector(
          'input[name="mode"][value="subscription"]'
        );
        if (subscriptionRadio && !subscriptionRadio.checked) {
          subscriptionRadio.click();
        }
      }
    });

    initRefillInfo(widget);
    initVariantPickerDiscount(widget);

    // --- Natulim DB 18/02/2026 Cambio: Escuchar cambios en el CONTENEDOR PADRE (product-info) ---
    // Los botones de variantes están fuera del form
    var productContainer = widget.closest('product-info') || widget.closest('.product') || widget.closest('form');

    if (productContainer) {
      var containerUpdateTimeout;
      productContainer.addEventListener('change', function (e) {
        // Si cambia el input "id" (variante) o cualquier radio button de opciones
        if (e.target.name === 'id' || e.target.name.includes('Option')) {
          // Debounce: evitar múltiples actualizaciones rápidas
          clearTimeout(containerUpdateTimeout);
          containerUpdateTimeout = setTimeout(function () {
            populateSellingPlanId();
            updateView();
          }, 10);
        }
      });
    }
  }

  // Variant Picker Discount functionality
  /*function initVariantPickerDiscount(widgetElement) {
    var widget = widgetElement || document.querySelector("#juo-subscription-widget");
    if (!widget) return;

    function updateVariantPickerDiscount() {
      var subscriptionMode = widget.querySelector(
        'input[name="mode"][value="subscription"]:checked'
      );
      var discountSpans = document.querySelectorAll(".variant-picker-discount");

      if (subscriptionMode) {
        discountSpans.forEach(function (span) { span.style.display = "inline"; });
      } else {
        discountSpans.forEach(function (span) { span.style.display = "none"; });
      }
    }

    setTimeout(function () { updateVariantPickerDiscount(); }, 200);

    var modeInputs = widget.querySelectorAll('input[name="mode"]');
    modeInputs.forEach(function (input) {
      input.addEventListener("change", updateVariantPickerDiscount);
    });

    widget.addEventListener("change", function (e) {
      if (e.target.name === "selling_plan") {
        updateVariantPickerDiscount();
      }
    });

    // Listeners globales
    document.addEventListener("natulimOptionValueChanged", function () { setTimeout(updateVariantPickerDiscount, 100); });
    document.addEventListener("variant:change", function () { setTimeout(updateVariantPickerDiscount, 100); });
  }
  */

  // CA-1 Natulim DB 03/03/2026 cambio: Reemplazar creación dinámica de spans con JS por toggle
  // de clase CSS en el contenedor padre (product-info), eliminando el flicker al cambiar variante.
  //
  // Por qué CSS class en vez de crear spans con JS:
  // - product-variant-options.liquid ya renderiza .variant-picker-discount en el servidor
  // - Cuando Dawn hace section rendering al cambiar variante, el nuevo HTML del servidor
  //   incluye los spans correctos. Si usamos JS para crearlos, desaparecen con el re-render
  //   y tardan en volver → flicker visible.
  // - Con CSS class en el contenedor padre (product-info), la clase persiste aunque Dawn
  //   reemplace el innerHTML interior. El CSS aplica inmediatamente → sin flicker.
  function initVariantPickerDiscount(widgetElement) {
    var widget = widgetElement || document.querySelector("#juo-subscription-widget");
    if (!widget) return;

    var productContainer = widget.closest('product-info') || widget.closest('.product') || widget.closest('form');
    if (!productContainer) return;

    function applyMode() {
      var isSubMode = !!widget.querySelector('input[name="mode"][value="subscription"]:checked');
      // Toggle instantáneo via CSS - sin DOM manipulation, sin setTimeout
      productContainer.classList.toggle('juo-sub-active', isSubMode);
    }

    // Estado inicial
    applyMode();

    // Escuchar cambio de modo (suscripción ↔ OTP)
    widget.addEventListener('change', function (e) {
      if (e.target.name === 'mode') {
        applyMode();
      }
    });

    // Compatibilidad con otros scripts que cambian la variante
    document.addEventListener('natulimOptionValueChanged', applyMode);
    document.addEventListener('variant:change', applyMode);
  }
  // FIN Natulim DB

  // Refill Info functionality
  function initRefillInfo(widgetElement) {
    var widget = widgetElement || document.querySelector("#juo-subscription-widget");
    if (!widget) return;

    var refillInfoElement = widget.querySelector(".juo-refill-info");
    if (!refillInfoElement) return;

    function updateRefillInfo() {
      if (!window.variantjson) window.variantjson = document.querySelector("#product-variants-data");

      // Natulim DB 18/02/2026 Cambio: Buscar input en el contenedor padre (product-info)
      var productContainer = widget.closest('product-info') || widget.closest('.product') || widget.closest('form');
      var inputVariant = productContainer ? productContainer.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');

      if (!inputVariant || !inputVariant.value) {
        refillInfoElement.textContent = "";
        return;
      }

      var variantId = inputVariant.value;
      var variantData = null;

      if (window.variantjson && window.variantjson.textContent) {
        try {
          variantData = JSON.parse(window.variantjson.textContent);
        } catch (e) { return; }
      } else { return; }

      if (!variantData) return;

      var getcurrentvariant = null;
      if (Array.isArray(variantData)) {
        getcurrentvariant = variantData.find(function (data) { return data.id.toString() == variantId.toString(); });
      } else if (variantData.variants) {
        getcurrentvariant = variantData.variants.find(function (data) { return data.id.toString() == variantId.toString(); });
      }

      if (!getcurrentvariant) {
        refillInfoElement.textContent = "";
        return;
      }

      var refillInfo = "";
      var refillPrice = "";

      if (getcurrentvariant.metafields) {
        if (getcurrentvariant.metafields.custom) {
          refillInfo = getcurrentvariant.metafields.custom.refill_info || "";
          refillPrice = getcurrentvariant.metafields.custom.refill_price || "";
        }
        if (!refillInfo && getcurrentvariant.metafields.refill_info) refillInfo = getcurrentvariant.metafields.refill_info;
        if (!refillPrice && getcurrentvariant.metafields.refill_price) refillPrice = getcurrentvariant.metafields.refill_price;
      }

      if (refillInfo || refillPrice) {
        refillInfoElement.innerHTML = '<span class="juo-refill-info__label" style="font-size: 14px;">' + refillInfo + '</span> <span class="juo-refill-info__amount" >' + refillPrice + "</span>";
        refillInfoElement.id = "juo-refill-info-" + getcurrentvariant.id;
      } else {
        refillInfoElement.textContent = "";
        refillInfoElement.id = "juo-refill-info-" + getcurrentvariant.id;
      }
    }

    setTimeout(function () { updateRefillInfo(); }, 100);

    // Listeners
    var productContainer = widget.closest('product-info') || widget.closest('.product') || widget.closest('form');
    var inputVariant = productContainer ? productContainer.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');
    if (inputVariant) inputVariant.addEventListener("change", updateRefillInfo);

    document.addEventListener("natulimOptionValueChanged", updateRefillInfo);
    document.addEventListener("variant:change", updateRefillInfo);
  }

  // --- Natulim DB 18/02/2026 Cambio: Soporte para Quick Add y Múltiples Widgets ---
  function main() {
    if (window.Shopify != null) {

      function initAllWidgets() {
        // Natulim DB 18/02/2026 Cambio: Buscamos por clase o atributo, no por ID, porque Quick Add puede cambiar los IDs
        var allWidgets = document.querySelectorAll(".juo-reset, [id*='juo-subscription-widget']");

        allWidgets.forEach(function (widgetEl) {
          if (widgetEl.classList.contains('juo-initialized')) return;

          // Buscar script JSON hermano
          var dataElement = null;
          var nextEl = widgetEl.nextElementSibling;
          while (nextEl) {
            // Natulim DB 18/02/2026 Cambio: Buscamos cualquier script JSON cercano, ignorando el ID exacto
            if (nextEl.tagName === 'SCRIPT' && (nextEl.id.includes('juo-subscription-widget-data') || nextEl.type === 'application/json')) {
              dataElement = nextEl;
              break;
            }
            nextEl = nextEl.nextElementSibling;
          }

          if (!dataElement) dataElement = document.getElementById("juo-subscription-widget-data");
          if (!dataElement || !dataElement.innerText) return;

          try {
            var data = JSON.parse(dataElement.innerText);
            var variants = data[0];
            var variantId = data[1];
            var moneyFormat = data[2];

            initWidget(variants, variantId, moneyFormat, widgetEl);
            widgetEl.classList.add('juo-initialized');

          } catch (error) {
            console.error("Juo Widget Error:", error);
          }
        });
      }

      if (document.readyState === "complete" || document.readyState === "interactive") {
        initAllWidgets();
      } else {
        document.addEventListener("DOMContentLoaded", initAllWidgets);
      }

      // Mutation Observer para Quick Add
      var observer = new MutationObserver(function (mutations) {
        var shouldInit = false;
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length) shouldInit = true;
        });
        if (shouldInit) setTimeout(initAllWidgets, 100);
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
})();